import CreateNewOrder from "../../components/NewDetail/CreateNewOrder";

const CreateOrder = () => {
  return <CreateNewOrder />;
};
export default CreateOrder;
